import React from 'react';
import Show from '../Show/Show';
import Tooltip from '../Tooltip/Tooltip';
import { Body1Reg } from '../../config/designSystem/typography';
import { COLORS } from '../../config/designSystem/Colors';
import { HeaderSide } from './HeaderSide';
import { SolarMenuDotsIcon } from '../../assets/images/solar/Menudots';
import { SolarSettingsIcon } from '../../assets/images/solar/Settings';
import { View } from 'react-native';
import { headerRightIconType } from './TopNavigation';


interface HeaderRightProps {
    topPosition: number,
    rightPosition: number,
    onPress: () => void,
    icon?: headerRightIconType
    onboarding?: boolean;
    onLeaveOnboarding?: () => void;
    labelOnboarding?: string;
}

export const SIZE_TOP_BAR = 40;
export const HeaderRight = ({ topPosition, rightPosition, onPress, icon,onboarding= false, labelOnboarding, onLeaveOnboarding }: HeaderRightProps) => {
  const SIZE= 24;
  return(
    <HeaderSide sidePosition={rightPosition} topPosition={topPosition} position={'right'} onPress={onPress}>
      <Tooltip
        from={(
          <View style={[!!onboarding && {backgroundColor: 'white'}]} >
            <Show when={icon === 'dots'}>
              <SolarMenuDotsIcon  color={COLORS.brand[500]} size={SIZE} />
            </Show>
            <Show when={icon === 'settings'}>
              <SolarSettingsIcon  color={COLORS.brand[500]} size={SIZE} />
            </Show>
          </View>
        )}
        isVisible={!!onboarding}
        placement="bottom"
        onClose={onLeaveOnboarding}
        // contentStyle={contentTooptipStyle}
        // tooltipStyle={tooptipStyle}
        // allowChildInteraction={false}
      >
        <Body1Reg> {labelOnboarding}</Body1Reg>
      </Tooltip>

    </HeaderSide>

  );
};




